<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main box-panel shadow max-w max-gs" id="page-content-main">
    <div class="">
      <epay-lib-employer-eft-home [eftInfo]="eftInfo">
      </epay-lib-employer-eft-home>
    </div>
  </div>
</epay-page-content>
